/* One column that fills the shell's body and scrolls inside itself. The shell's body is a twelve-column
   grid for the screens that have not moved over; this page takes the whole of it. */
.page {
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
}

.chart {
  flex: 0 0 auto;
  min-width: 0;
  padding: 12px 16px;
}

/* The table card takes what is left, never less than a few rows, and its grid scrolls inside it. */
.tableCard {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 280px;
}

/* A `state` is not a grid: it has no scroller of its own and may be as long as a settings page. The
   card is as tall as what it holds (never less than the few rows above) and the page scrolls to the
   rest, so nothing is cut off by the clip below at a small window or a large zoom. */
.tableCard[data-state] {
  flex: 1 0 auto;
}

/* A page with cards after its table lets the table be as tall as its rows, to 70% of the window. */
.tableCard[data-fits-rows] {
  flex: 0 0 auto;
  min-height: 0;
  max-height: max(280px, 70vh);
}

/* Clipped at the card's lower corners only: the filter line above holds option lists that open
   downward over the table and must not be cut off. */
.body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  border-radius: 0 0 var(--radius-card) var(--radius-card);
}

.body > :first-child {
  flex: 1 1 auto;
  min-height: 0;
}

/* A failed read that sits *above* the table (a list of sites that could not be read, the invitations
   waiting) is a notice, not a pane. As the body's first child it took the rule above and was squeezed
   to a sliver by the grid beneath it, with its Try again button cut off - in the DOM and not on the
   screen (E2E P9, G-P9-18, -19, -20). It keeps the height of its own words. It comes after the rule it
   overrides: the two selectors weigh the same. */
.body > [data-testid="read-failed"] {
  flex: 0 0 auto;
}


